// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1CBAT","insightsList":"newBusinessInsightsMenu_insightsList__1i-xX","active":"newBusinessInsightsMenu_active__2oz_c"};